import { Form } from 'antd'

import locale from 'antd/es/date-picker/locale/de_DE'
import Button from 'components/Button/index'
import DatePicker from 'components/DatePickerStyled/DatePicker'
import { DateRangePicker } from 'components/DatePickerStyled/DateRangePicker/index'
import Flex from 'components/Flex'
import Checkbox from 'components/Form/Checkbox'
import Input from 'components/Form/Input'
import {
  default as Radio,
  default as RadioButton,
} from 'components/Form/RadioButton'
import TextAreas from 'components/Form/TextArea'
import RangeSlider from 'components/RangeSlider/index'
import Select from 'components/Select/index'
import SelectDropDown from 'components/SelectWithCheckBox'
import { RadioGroup } from 'components/UIComponents/FormStyles'
import AlarmIcon from 'components/icons/AlarmIcon'
import DeleteIcon from 'components/icons/DeleteIcon'
import LinkIcon from 'components/icons/LinkIcon'
import PlusWhiteIcon from 'components/icons/PlusBlueIcon'
import PencilIconImage from 'components/icons/pencilImage.png'
import CandidateDetails from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/Components/CandidateDetails'
import SelectMode from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/Components/SelectMode/index'

const dropdownRender = (
  menu,
  interviewType,
  linkPanelData,
  onClickNone,
  name
) => {
  return (
    <>
      {interviewType === 'ASSESMENT' && (
        <Fragment>
          <NoneContainer onClick={onClickNone}>
            <Flex column>
              <TextWrapper>Available</TextWrapper>
              <Flex row spaceBetween>
                <NoneWrapper centerVertically>None</NoneWrapper>
                <RadioGroup
                  value={
                    linkPanelData[name]?.panel[0]?.id === null
                      ? 'None'
                      : linkPanelData[name]?.panel.map(({ id }) => id)
                  }
                >
                  <RadioButton value={'None'} />
                </RadioGroup>
              </Flex>
            </Flex>
          </NoneContainer>
          <Diveder />
        </Fragment>
      )}
      {menu}
    </>
  )
}

import {
  Commondiv,
  Diveder,
  FormItem,
  IconWrapper,
  NoneContainer,
  NoneWrapper,
  SessionFlex,
  StartSpan,
  StyledTag,
  TextWrapper,
  TimeInfoSpan,
  TimeStyles,
  TotalTimeDiv,
} from 'modules/Drives/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/style'
import moment from 'moment'
import React, { Fragment, useEffect, useState } from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { EmptyElement } from '../../../../../components/UIComponents/CommonStyledDiv'
import {
  assessmentOptions,
  optionTime,
  RadioDriveOptions,
} from '../../../../../utils/commonFunction'

const ScheduleInterviewForm = ({
  form,
  selectedCandidate,
  rolesMetrics,
  driveInterViewerList,
  driveData,
  candidateDeatils,
  SelectedRoundName,
  interviewMode,
  isOneDayDrive,
  linkPanelData,
  addedInterviewer,
  interviewInfo,
  isSingleOrBulk,
  interviewType,
  dateFormat,
  candidates,
  setCandidates,
  handleIterviewRound,
  disabledDate,
  onChangeDate,
  onDurationChange,
  onTimeChange,
  onChangeMode,
  onChangeLink,
  onClickNone,
  onSelectInterview,
  onSubmitFormData,
  selectedRoundType,
  setLinkPanelData,
  disabledStartDate,
  disabledEndDate,
  onChangeStartDate,
  onChangeEndDate,
  selectingStartDate,
  selectingEndDate,
  isAssesemntType,
  dateRange,
  interviewList,
  getUpdatedList,
  isBulk,
  inteviewer,
  parametersList,
  setParametersList,
  onEndTimeChange,
  check,
  setCheck,
  status,
  driveId,
  roleId,
  getCandidateScoreList,
  stage,
  lastPanelId,
}) => {
  const [inputText, setInputText] = useState('')

  const [rescheduleData, setRescheduleData] = useState([])

  let linkPanelInitialValue = {
    link: '',
    panel:
      interviewType === 'ASSESMENT'
        ? [
            {
              id: null,
              firstName: null,
              lastName: null,
            },
          ]
        : [],
  }

  useEffect(() => {
    form.setFieldsValue({
      linkAndPanel: [linkPanelInitialValue],
    })
  }, [])

  useEffect(() => {
    getUpdatedList()
  }, [linkPanelData])
const activeInterviewList = interviewList?.filter(
  (item) => item?.is_active === true
);
  const addToForm = () => {
    getUpdatedList()
    if (interviewMode === 'OFFLINE') {
      setLinkPanelData([
        ...linkPanelData,
        {
          panel: [
            {
              id: null,
              firstName: null,
              lastName: null,
            },
          ],
        },
      ])
    } else if (
      interviewMode === 'EXTERNAL_LINK' &&
      interviewType === 'ASSESMENT'
    ) {
      setLinkPanelData([...linkPanelData, { link: null }])
    } else {
      setLinkPanelData([...linkPanelData, linkPanelInitialValue])
    }
  }

  const onRemove = name => {
    if (linkPanelData?.length <= 1) {
      ErrorMessage('Minimum One Panel is Required')
      form.setFieldsValue({
        linkAndPanel: [linkPanelInitialValue],
      })
    }

    setLinkPanelData(linkPanelData?.filter((data, index) => index !== name))
  }

  const copyLinkText = link => {
    if (link) {
      navigator.clipboard.writeText(link)
      SuccessMessage('Link Copied!!')
    }
  }
  useEffect(() => {
    form.setFieldValue({
      mode: interviewMode,
    })
  }, [])
  const handleInputChange = e => {
    setInputText(e.target.value)
  }
  const addParameter = () => {
    if (
      inputText?.trim() !== '' &&
      inputText &&
      parametersList.indexOf(inputText?.toUpperCase()) === -1
    ) {
      setParametersList([...parametersList, inputText?.trim()?.toUpperCase()])
      setInputText('')
    } else {
      setInputText('')
      ErrorMessage('Evaluation parameter is already exists. ')
    }
  }
  const handleClose = removedTag => {
    const newTags = parametersList.filter(tag => tag !== removedTag)
    setParametersList(newTags)
  }
  const handleEdit = removedTag => {
    setInputText(removedTag)
    const newTags = parametersList.filter(tag => tag !== removedTag)
    setParametersList(newTags)
  }
  const getCandidateScore = async () => {
    let status = 'RESCHEDULE'
    setRescheduleData([])

    let response = await getCandidateScoreList({
      driveId: driveId,
      roleId: roleId,
      stage,
      status,
    })
    if (response?.status >= 200 && response?.status <= 300) {
      setRescheduleData(response?.data?.data || [])
    }
  }
  useEffect(() => {
    getCandidateScore()
  }, [])

  const typeLabels = {
    ASSESMENT: 'Assessment',
    GROUP: 'Group Discussion',
    FACE_TO_FACE: 'Interview',
    EXTERNAL_ASSESMENT: 'External Assessment',
  }
  const assessmentTypes = {
    COGNITIVE: 'Cognitive',
    TECHNICAL: 'Technical',
    COMUNICATION: 'Communication',
  }
  const assesmentOptions =
    assessmentTypes[selectedRoundType?.assesmentType] || ''
  const labelText = typeLabels[selectedRoundType?.type] || ''

  let max

  if (status?.includes('RESCHEDULE')) {
    max = Number(rescheduleData?.count || 0)
  } else if (isBulk) {
    max =
      Number(candidateDeatils?.count || 0) + Number(rescheduleData?.count || 0)
  } else {
    max =
      Number(selectedCandidate?.length || 0) +
      Number(rescheduleData?.count || 0)
  }

  return (
    <Form
      scrollToFirstError
      onFinish={onSubmitFormData}
      id={'scheduleForm'}
      form={form}
      layout="vertical"
      initialValues={{
        linkAndPanel: [linkPanelInitialValue],
      }}
    >
      {}
      {status == 'SCHEDULED,TO_BE_SCHEDULED' && (
        <CandidateDetails
          text={`Candidates `}
          selectedCandidate={selectedCandidate}
          count={isBulk ? candidateDeatils?.notDisabledCount : selectedCandidate?.length}
          isBulk={isBulk}
        />
      )}
      {rescheduleData?.count > 0 && (
        <div>
          <CandidateDetails
            text={`Reschedule Line-up `}
            selectedCandidate={rescheduleData?.result}
            count={rescheduleData?.count}
            isBulk={isBulk}
          />
        </div>
      )}
      {}
      <FormItem
        name={'interviewRound'}
        rules={[{ required: true, message: 'Please select round name!' }]}
      >
        <TotalTimeDiv>
          Round Name<StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <Select
          OptionData={rolesMetrics[0]?.rounds}
          nameParam="roundName"
          valueParam="roundName"
          placeholder="Round Name"
          onChange={handleIterviewRound}
          value={SelectedRoundName}
          disabled={true}
        />
      </FormItem>
      <FormItem
        name={'interviewType'}
        rules={[
          {
            required: true,
            message: 'Please select Evaluation type!',
          },
        ]}
      >
        <TotalTimeDiv>
          Evaluation Type <StartSpan>*</StartSpan>
        </TotalTimeDiv>
        <Input
          width="100%"
          placeholder={'Please Enter Evaluation Parameters'}
          value={
            labelText +
            (selectedRoundType?.assesmentType ? ' - ' + assesmentOptions : '')
          }
          disabled
        />
        <div style={{ display: 'none' }}>
          <RadioGroup spaceBetween value={selectedRoundType?.type}>
            {RadioDriveOptions?.map((item, index) => (
              <Radio
                key={index + item?.value}
                border={true}
                label={item?.label}
                value={item?.value}
                width={'100%'}
                disable={true}
              />
            ))}
          </RadioGroup>
        </div>
      </FormItem>
      {interviewType === 'ASSESMENT' && (
        <div style={{ display: 'none' }}>
          <FormItem>
            <TotalTimeDiv>
              Assesment Type <StartSpan>*</StartSpan>
            </TotalTimeDiv>
            <RadioGroup spaceBetween value={selectedRoundType?.assesmentType}>
              {assessmentOptions?.map((item, index) => (
                <Radio
                  key={index + item?.value}
                  border={true}
                  label={item?.label}
                  value={item?.value}
                  width={'100%'}
                  disable={true}
                />
              ))}
            </RadioGroup>
          </FormItem>
        </div>
      )}
      {interviewType == 'GROUP' && (
        <FormItem
          marginbottom={'0px'}
          name={'candidatesPerGroup'}
          rules={[
            // {
            //   required: true,
            //   message: 'Please select no. of candidates per group!',
            // },
            {
              validator: (_, value) => {
                if (!value) {
                  // Check if the value is empty and reject if required validation fails
                  return Promise.reject(
                    new Error('Please select no. of candidates per group!')
                  )
                }
                if (value <= 1) {
                  return Promise.reject(
                    new Error('Please select more than 1 candidate!')
                  )
                } else {
                  return Promise.resolve()
                }
              },
            },
          ]}
        >
          <Commondiv padding={'4px'}>
            <TotalTimeDiv>Select no. of candidates per group</TotalTimeDiv>
            <RangeSlider
              inputValue={candidates}
              setInputValue={setCandidates}
              min={0}
              max={max}
              percentage={false}
              sliderrules={[
                {
                  required: true,
                  message: 'required',
                },
                {
                  validator: (_, value) => {
                    if (value >= 0 && value <= selectedCandidate?.length) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(new Error('Not Valid'))
                    }
                  },
                },
              ]}
              inputDis
            />
          </Commondiv>
        </FormItem>
      )}
      {status == 'SCHEDULED,TO_BE_SCHEDULED' && rescheduleData?.count > 0 && (
        <Flex>
          <FormItem name={'forScheduleORReschedule'}>
            <SessionFlex>
              <Checkbox
                checked={check}
                label={
                  `Add ` +
                  `${rescheduleData?.count}` +
                  ` candidates who need to be rescheduled`
                }
                onClick={() => setCheck(!check)}
              />
            </SessionFlex>
          </FormItem>
        </Flex>
      )}
      <Flex>
        <FormItem
          name={'mode'}
          rules={[
            {
              required: true,
              message: 'Please select mode!',
            },
          ]}
        >
          <Flex column>
            <TotalTimeDiv>
              Mode<StartSpan>*</StartSpan>
            </TotalTimeDiv>
            <SelectMode
              width="350px"
              onChange={onChangeMode}
              placeholder={'Add Mode'}
              disabled={interviewType === 'EXTERNAL_ASSESMENT'}
              value={form.getFieldValue('mode')}
              getPopupContainer={() => document.getElementById('mode')}
            />
          </Flex>
        </FormItem>
        {(interviewType === 'ASSESMENT' ||
          interviewType === 'EXTERNAL_ASSESMENT') &&
          interviewMode === 'EXTERNAL_LINK' && (
            <FormItem
              name={'linkExpireAt'}
              rules={[
                {
                  required: true,
                  message: 'Please select date!',
                },
              ]}
            >
              <Flex column>
                <TotalTimeDiv margin={'2px'}>
                  Link Validity <StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <DatePicker
                  width="100%"
                  placeholder={'Select Date'}
                  dateFormat="DD/MM/YYYY  HH:mm"
                  disabledDate={
                    isAssesemntType ? disabledStartDate : disabledDate
                  }
                  onChange={(date, dateString) =>
                    form.setFieldsValue({
                      linkExpireAt: moment(
                        dateString,
                        'DD/MM/YYYY HH:mm'
                      ).format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                    })
                  }
                  showTime
                />
              </Flex>
            </FormItem>
          )}
      </Flex>

      {isAssesemntType ? (
        <SessionFlex row centerVertically>
          <FormItem>
            <TotalTimeDiv>
              Start Date <StartSpan>*</StartSpan>
            </TotalTimeDiv>
            <div id={'start_dates'}>
              <DatePicker
                name={'startDate'}
                rules={[
                  {
                    required: true,
                    message: 'Please select start date!',
                  },
                ]}
                id={'startdate'}
                width="100%"
                getPopupContainer={() => document.getElementById('start_dates')}
                placeholder={'Start Date'}
                dateFormat={'DD/MM/YYYY'}
                disabledDate={disabledStartDate}
                showToday={false}
                showNow={false}
                onChange={onChangeStartDate}
                value={moment(selectingStartDate, 'DD/MM/YYYY')}
                allowClear={false}
              />
            </div>
          </FormItem>
          <FormItem>
            <TotalTimeDiv>
              End Date (To be Completed By) <StartSpan>*</StartSpan>
            </TotalTimeDiv>
            <div id={'end_dates'}>
              <DatePicker
                name={'endDate'}
                rules={[
                  {
                    required: true,
                    message: 'Please select end date!',
                  },
                ]}
                id={'enddate'}
                width="100%"
                placeholder={'End Date'}
                dateFormat={'DD/MM/YYYY'}
                disabledDate={disabledEndDate}
                showToday={false}
                showNow={false}
                onChange={onChangeEndDate}
                value={moment(selectingEndDate, 'DD/MM/YYYY')}
                getPopupContainer={() => document.getElementById('end_dates')}
                allowClear={false}
                disabled={!selectingStartDate}
              />
            </div>
          </FormItem>
        </SessionFlex>
      ) : (
        <FormItem
          name={'dates'}
          rules={[
            {
              required: true,
              message: 'Please select date!',
              validator: (_, value) => {
                if (value?.length != 2 && !isOneDayDrive) {
                  return Promise.reject(new Error('Please Enter date!'))
                } else {
                  return Promise.resolve()
                }
              },
            },
          ]}
        >
          <TotalTimeDiv>
            Date <StartSpan>*</StartSpan>
          </TotalTimeDiv>
            {/* <div id={'start_date'}>
              <DatePicker
                width="100%"
                placeholder={'Select Date'}
                dateFormat={'DD/MM/YYYY'}
                disabled={true}
                getPopupContainer={() => document.getElementById('start_date')}
                defaultValue={moment(driveData?.startDate, dateFormat)}
                disabledDate={disabledDate}
              />
            </div> */}
            <div id={'end_date'}>
              <DateRangePicker
                width="100%"
                format={'DD/MM/YYYY'}
                placeholder={['StartDate', 'EndDate']}
                picker={'date'}
                disabledDate={disabledDate}
                onChange={onChangeDate}
                defaultValue={dateRange}
                getPopupContainer={() => document.getElementById('end_date')}
              />
            </div>
        </FormItem>
      )}
      <Flex>
        <FormItem ismargin>
          <SessionFlex row centerVertically>
            <div>
              <FormItem
                name={'duration'}
                rules={[
                  {
                    required: true,
                    message: 'Please select duration!',
                  },
                ]}
              >
                <TotalTimeDiv>
                  Duration <StartSpan>*</StartSpan>
                </TotalTimeDiv>
                <Select
                  width="350px"
                  OptionData={optionTime}
                  nameParam="label"
                  valueParam="value"
                  placeholder="Duration"
                  onChange={onDurationChange}
                  id={'duration'}
                  showSearch
                />
              </FormItem>
            </div>
          </SessionFlex>
          {!(
            (interviewType === 'ASSESMENT' ||
              interviewType === 'EXTERNAL_ASSESMENT') &&
            interviewMode === 'EXTERNAL_LINK'
          ) && (
            <Flex>
              <FormItem ismargin>
                <SessionFlex row centerVertically>
                  <FormItem
                    name={'startTime'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select time!',
                      },
                    ]}
                  >
                    <Flex spaceBetween centerVertically>
                      <TotalTimeDiv margin={'2px'}>
                        Start Time <StartSpan>*</StartSpan>
                      </TotalTimeDiv>
                      {}
                    </Flex>
                    <div id={'start_time'}>
                      <TimeStyles
                        suffixIcon={<AlarmIcon />}
                        placeholder="Select Time"
                        locale={{
                          ...locale,
                          lang: {
                            ...locale.lang,
                            now: 'Now',
                            ok: 'Confirm',
                          },
                        }}
                        onChange={onTimeChange}
                        // disabledTime={(_, type) =>
                        //   disabledRangeTime(_, type, driveData)
                        // }
                        format={'HH:mm'}
                        getPopupContainer={() =>
                          document.getElementById('start_time')
                        }
                      />
                    </div>
                  </FormItem>
                  <FormItem
                    name={'endTime'}
                    rules={[
                      {
                        required: true,
                        message: 'Please select time!',
                      },
                    ]}
                  >
                    <Flex spaceBetween centerVertically>
                      <TotalTimeDiv margin={'2px'}>
                        End Time <StartSpan>*</StartSpan>
                      </TotalTimeDiv>
                      {}
                    </Flex>
                    <div id={'end_time'}>
                      <TimeStyles
                        suffixIcon={<AlarmIcon />}
                        placeholder="Select Time"
                        locale={{
                          ...locale,
                          lang: {
                            ...locale.lang,
                            now: 'Now',
                            ok: 'Confirm',
                          },
                        }}
                        onChange={onEndTimeChange}
                        // disabledTime={(_, type) =>
                        //   disabledRangeTime(_, type, driveData)
                        // }
                        format={'HH:mm'}
                        getPopupContainer={() =>
                          document.getElementById('end_time')
                        }
                      />
                    </div>
                  </FormItem>
                </SessionFlex>
              </FormItem>
            </Flex>
          )}
        </FormItem>
      </Flex>
      {interviewType !== 'ASSESMENT' &&
        interviewType !== 'EXTERNAL_ASSESMENT' && (
          <>
            <FormItem
              ismargin={true}
              name={'parameters'}
              rules={[
                {
                  validator: (_, value) => {
                    if (parametersList?.length === 0) {
                      return Promise.reject(
                        new Error('Please Enter Evaluation Parameters')
                      )
                    } else {
                      return Promise.resolve()
                    }
                  },
                },
              ]}
            >
              <TotalTimeDiv>
                Evaluation Parameters <StartSpan>*</StartSpan>
              </TotalTimeDiv>
              <Input
                width="100%"
                placeholder={'Please Enter Evaluation Parameters'}
                value={inputText}
                onChange={handleInputChange}
              />
            </FormItem>
            <br></br>
            <Flex wrap>
              {parametersList?.map((item, index) => (
                <Flex
                  style={{ paddingRight: '10px' }}
                  key={index + 'paraParamList'}
                >
                  <StyledTag key={item}>{item?.toLowerCase()}</StyledTag>
                  <EmptyElement
                    style={{ paddingTop: '8px' }}
                    onClick={() => handleEdit(item)}
                  >
                    {' '}
                    <img src={PencilIconImage} alt="editIcon" />
                  </EmptyElement>
                  <EmptyElement
                    style={{ paddingTop: '8px' }}
                    onClick={() => handleClose(item)}
                  >
                    {' '}
                    <DeleteIcon />
                  </EmptyElement>
                </Flex>
              ))}
            </Flex>

            <Button.Secondary
              text={'Add'}
              width="100%"
              icon={<PlusWhiteIcon />}
              dashed="true"
              onClick={() => {
                addParameter()
              }}
            />
            <br></br>
          </>
        )}
      {interviewMode === 'OFFLINE' && (
        <FormItem>
          <Flex spaceBetween>
            <TotalTimeDiv>
              Location <StartSpan>*</StartSpan>
            </TotalTimeDiv>
          </Flex>
          <TextAreas
            marginbottom={'0px'}
            name={'location'}
            placeholder={'Add Location'}
            onChange={(e) => {
              const value = e.target.value;
              // Update form value
              form.setFieldsValue({ location: value });
              // Clear error if value exists
              if (value && value.trim()) {
                form.setFields([
                  {
                    name: 'location',
                    errors: []
                  }
                ]);
              }
            }}
            onBlur={(e) => {
              const value = e.target.value;
              // Show error only if field is empty on blur
              if (!value || !value.trim()) {
                form.setFields([
                  {
                    name: 'location',
                    errors: ['Please enter the location!']
                  }
                ]);
              }
            }}
            rules={[
              {
                validator: (_, value) => {
                  if (!value || !value.trim()) {
                    return Promise.reject(new Error('Please enter the location!'));
                  }
                  return Promise.resolve();
                }
              }
            ]}
          />
        </FormItem>
      )}

      {interviewMode !== 'OFFLINE' && (
        <Form.List name="linkAndPanel">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name }) => (
                  <SessionFlex spaceBetween centerVertically key={key + name}>
                    <FormItem>
                      <TotalTimeDiv>
                        Link <StartSpan>*</StartSpan>
                      </TotalTimeDiv>
                      <Input
                        width="100%"
                        suffix={
                          <IconWrapper
                            noBottom
                            onClick={() =>
                              copyLinkText(linkPanelData[name]?.link)
                            }
                          >
                            <LinkIcon />
                          </IconWrapper>
                        }
                        placeholder="Add Link"
                        onChange={e => onChangeLink(e, name)}
                        name={[name, 'link']}
                        type="url"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter valid link!',
                          },
                        ]}
                      />
                    </FormItem>

                    {interviewType !== 'ASSESMENT' &&
                      interviewType !== 'EXTERNAL_ASSESMENT' && (
                        <FormItem
                          name={[name, 'panel']}
                          rules={[
                            {
                              required: true,
                              message: 'Please select interviewer!',
                            },
                          ]}
                        >
                          <TotalTimeDiv>
                            Interviewer/Panel {lastPanelId + (name + 1)} *
                          </TotalTimeDiv>
                          <div id={name + 1}>
                            <SelectDropDown
                              key={name} // Add a unique key using the 'name' prop
                              width="100%"
                              showSearch={false}
                              optionDivData={activeInterviewList}
                              maxTagCount={1}
                              isInterviewer={true}
                              valueParam="_id"
                              nameParam="first_name"
                              lastNameParam="last_name"
                              optionLabelProp={'label'}
                              placement={'bottomLeft'}
                              placeholder={'Select Interviewers'}
                              dropdownMatchSelectWidth={false}
                              dropdownStyle={{ width: '20%' }}
                              value={
                                linkPanelData[name]?.panel[0]?.id === null
                                  ? []
                                  : linkPanelData[name]?.panel.map(
                                      ({ id }) => id
                                    )
                              }
                              onChange={(value, option) =>
                                onSelectInterview(value, option, name)
                              }
                              getPopupContainer={() =>
                                document.getElementById(name + 1)
                              }
                            />
                          </div>
                        </FormItem>
                      )}
                    {isSingleOrBulk &&
                      interviewType !== 'ASSESMENT' &&
                      interviewType !== 'EXTERNAL_ASSESMENT' && (
                        <IconWrapper
                          center
                          onClick={() => {
                            remove(name)
                            onRemove(name)
                          }}
                          disable={linkPanelData?.length === 1}
                        >
                          <DeleteIcon />
                        </IconWrapper>
                      )}
                  </SessionFlex>
                ))}
                {isSingleOrBulk &&
                  interviewType !== 'ASSESMENT' &&
                  interviewType !== 'EXTERNAL_ASSESMENT' && (
                    <Form.Item>
                      <Button.Secondary
                        text={'Add'}
                        width="100%"
                        icon={<PlusWhiteIcon />}
                        dashed="true"
                        onClick={() => {
                          addToForm()
                          add()
                        }}
                      />
                    </Form.Item>
                  )}
              </>
            )
          }}
        </Form.List>
      )}
      {interviewMode === 'OFFLINE' && (
        <Form.List name="linkAndPanel">
          {(fields, { add, remove }) => {
            return (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <SessionFlex spaceBetween centerVertically key={key}>
                    <FormItem
                      name={[name, 'panel']}
                      rules={[
                        {
                          required: true,
                          message: 'Please select interviewer!',
                        },
                      ]}
                    >
                      <TotalTimeDiv>Interviewer/Panel {name + 1}</TotalTimeDiv>
                      <div id={name + 1}>
                        <SelectDropDown
                          width="100%"
                          optionDivData={activeInterviewList}
                          showSearch={false}
                          maxTagCount={1}
                          isInterviewer={true}
                          valueParam="_id"
                          nameParam="first_name"
                          lastNameParam="last_name"
                          optionLabelProp={'label'}
                          placement={'bottomLeft'}
                          placeholder={'Select Interviewers'}
                          dropdownMatchSelectWidth={false}
                          dropdownStyle={{ width: '20%' }}
                          mode={
                            interviewType === 'ASSESMENT' &&
                            linkPanelData[name]?.panel[0]?.id === null
                              ? ''
                              : 'multiple'
                          }
                          onChange={(value, option) =>
                            onSelectInterview(value, option, name)
                          }
                          value={
                            interviewType === 'ASSESMENT' &&
                            linkPanelData[name]?.panel[0]?.id === null
                              ? 'None'
                              : linkPanelData[name]?.panel[0]?.id === null
                              ? []
                              : linkPanelData[name]?.panel.map(({ id }) => id)
                          }
                          getPopupContainer={() =>
                            document.getElementById(name + 1)
                          }
                          dropdownRender={menu =>
                            dropdownRender(
                              menu,
                              interviewType,
                              linkPanelData,
                              onClickNone,
                              name
                            )
                          }
                        />
                      </div>
                    </FormItem>

                    {isSingleOrBulk && interviewType !== 'ASSESMENT' && (
                      <IconWrapper
                        center
                        onClick={() => {
                          remove(name)
                          onRemove(name)
                        }}
                        disable={linkPanelData?.length === 1}
                      >
                        <DeleteIcon />
                      </IconWrapper>
                    )}
                  </SessionFlex>
                ))}
                {isSingleOrBulk && interviewType !== 'ASSESMENT' && (
                  <Form.Item>
                    <Button.Secondary
                      text={'Add'}
                      width="100%"
                      icon={<PlusWhiteIcon />}
                      dashed="true"
                      onClick={() => {
                        add()
                        addToForm()
                      }}
                    />
                  </Form.Item>
                )}
              </>
            )
          }}
        </Form.List>
      )}
      <FormItem>
        <Flex spaceBetween>
          <TotalTimeDiv>
            Note/Instructions<StartSpan>*</StartSpan>
          </TotalTimeDiv>
          <TimeInfoSpan>Visible to the candidate</TimeInfoSpan>
        </Flex>
        <TextAreas
          marginbottom={'0px'}
          name={'instructions'}
          placeholder={'Add Note for the Candidates'}
          required
          value={interviewInfo?.instructions}
          onChange={(e) => {
            form.setFieldsValue({ instructions: e.target.value })
          }}
          rules={[
            {
              validator: (_, value) => {
                if (!value || !value.trim()) {
                  return Promise.reject(
                    new Error('Please add a note/instructions for the candidates!')
                  )
                }
                return Promise.resolve()
              },
            },
          ]}
        />
      </FormItem>
    </Form>
  )
}

export default ScheduleInterviewForm
